import {
  ADMIN_SETTINGS_TAB_SECTIONS,
  type AdminSettingsSection,
  type AdminSettingsTab,
} from "./-admin-settings-tab-sections";

export interface AdminSettingsSearch {
  tab: AdminSettingsTab;
  section: AdminSettingsSection;
}

const legacyLinks: { value: string; target: AdminSettingsSearch }[] = [
  { value: "deal-alerts", target: { tab: "offers", section: "drop-policy" } },
  { value: "deal-discovery", target: { tab: "offers", section: "drop-policy" } },
  { value: "whatsapp", target: { tab: "channels", section: "whatsapp" } },
  { value: "email", target: { tab: "channels", section: "email" } },
  { value: "taste", target: { tab: "personalization", section: "taste" } },
  { value: "taxonomy-rules", target: { tab: "catalog", section: "taxonomy" } },
];

/** Resolves direct and existing settings links to a valid section within its tab. */
export function parseAdminSettingsSearch(raw: {
  tab?: unknown;
  section?: unknown;
}): AdminSettingsSearch {
  const legacy = legacyLinks.find((link) => link.value === raw.tab);
  if (legacy) return legacy.target;
  const tab =
    ADMIN_SETTINGS_TAB_SECTIONS.find((tab) => tab.value === raw.tab) ??
    ADMIN_SETTINGS_TAB_SECTIONS[0];
  const section = tab.sections.find((section) => section === raw.section) ?? tab.sections[0];
  return { tab: tab.value, section };
}
